import {
  CircularProgress as MuiCircularProgress,
  CircularProgressProps,
} from "@mui/material/";

const CircularProgress = ({ ...rest }: CircularProgressProps): JSX.Element => {
  return (
    <div>
      <MuiCircularProgress {...rest} />
    </div>
  );
};

export default CircularProgress;
